export default __webpack_public_path__ + "static/assets/68d569de267914702368577db275542f.svg";